<template>
	<div v-click-outside="clickOutside" class="ajax-autocomplete-input">
		<div class="aai-loading fade in" v-if="isLoading">
			<span class="spinner spinner-xs"></span>
		</div>
		
		<div class="input-box" ref="inputbox" @click="onClickParent">
			<ul class="aai-selected-list">
				<li v-if="showPlaceholder&&value.length===0" class="aai-placeholder">{{placeholder}}</li>
				<li class="aai-selected-item" v-for="(selectedItem,selectedItemIndex) in value" :key="selectedItem[idAttr]">
					<span class="aai-selected-item-img" v-if="$eval('selectedItem.'+imgAttr, selectedItem)!=undefined" v-on:click="deleteSelectedItem(selectedItemIndex)">
						<img :src="$eval('selectedItem.'+imgAttr, selectedItem)" width="24" height="24" />
					</span>
					<span class="aai-txt">{{selectedItem[titleAttr]}}</span>
				</li>
				<li>
					<input v-on:focus="onFocus" v-on:focusout="onFocusOut" ref="searchfield" v-model="search" v-on:keyup="onKeyUp" v-on:keydown="onKeyDown" :class="inputClass" type="text" />
				</li>
			</ul>
			
		</div>
		<div ref="searchresults" class="aii-results-parent">
			<ul ref="scrollbar" class="aai-results" v-if="results.length" :style="{'max-height': resultsMaxHeight + 'px'}">
				<li class="aai-single-res" v-for="(result, idx) in results" v-bind:key="result[idAttr]" v-on:click="itemClicked(result)" :class="[{'has-image': $eval('result.'+imgAttr, result)!=undefined}, {'has-subtitle': result[subtitleAttr]!=undefined}, {'just-title': $eval('result.'+imgAttr)===undefined&&result[subtitleAttr]===undefined}, {'aai-res-active': (value.length&&getIndexOf(result[idAttr])!=-1)}, {'active': keyboardCurrentItem===idx}]">
					<img :src="$eval('result.'+imgAttr, result)" v-if="$eval('result.'+imgAttr, result)!=undefined" width="38" height="38"/>
					<div class="ajax-autocomplete-input-txts">
						<span class="ajax-autocomplete-input-title">{{result[titleAttr]}}</span>
						<span v-if="result[subtitleAttr]!=undefined" class="ajax-autocomplete-input-subtitle">{{result[subtitleAttr]}}</span>
					</div>
				</li>
			</ul>
			<div v-if="tag===false&&noResults&&search!=''" class="aai-nores">
				{{noResultTxt}}
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import PerfectScrollbar from 'perfect-scrollbar';
	import ClickOutside from 'vue-click-outside'

	export default {
		directives: {
			ClickOutside
		},
		data() {
			return {
			    keyboardCurrentItem: -1,
				search: '',
				results: [],
				lastVal: '',
				searchRequestManager: null,
				isLoading: false,
				noResults: false,
				showPlaceholder: true
			}
		},
		props: {
		    tag: {
		        type: Boolean,
				default: false,
			},
			inputClass: {
				type: Array,
				default: function () { return [] },
				validator: (classes) => classes.every(e => typeof e === 'string')
			},
			ajaxUrl: {
				type: String,
				default: "https://core.vowave.com/api/v1/search/users"
			},
			nonAjaxData: {
				type: Array,
				default: () => ([])
			},
			titleAttr: {
				type: String,
				default: "title"
			},
			subtitleAttr: {
				type: String,
				default: "subtitle"
			},
			imgAttr: {
				type: String,
				default: "photos.avatar"
			},
			idAttr: {
				type: String,
				default: "id"
			},
			addToInput: {
				type: Boolean,
				default: false
			},
			value: {
				type: Array,
				default: () => ([])
			},
			headers: {
				type: Object,
				default: () => ({})
			},
			resultsMaxHeight: {
				type: String,
				default: "150"
			},
			noResultTxt: {
				type: String,
				default: "No result found."
			},
			removeSelectedOnClickSearchResults: {
				type: Boolean,
				default: true
			},
			placeholder: {
				type: String,
				default: "Placeholder"
			},
			maxSelect: {
			    type: Number,
				default: 0
			}
		},
		created() {
			let vm = this
			window.addEventListener('scroll', function() {
				if(vm.$refs.searchfield!=undefined && document.activeElement===vm.$refs.searchfield) {
					vm.updateResultPosition()
				}
			});
			// window.document.body.onscroll = function() {
			// 	vm.updateResultPosition()
			// 	let searchInputs = document.getElementsByClassName('aai-search-input')
			// 	if(searchInputs.length===1 || searchInputs[searchInputs.length-1]!=vm.$refs.searchfield) {
			// 		window.document.body.onscroll()
			// 	}
			// }
			window.document.body.onresize = function() {
				if(document.activeElement===vm.$refs.searchfield) {
					vm.updateResultPosition()
				}
			}
		},
		methods: {
            '$eval'(expr, obj) {
                let splited = expr.split('.')
                let tagName = splited[0]
                window[tagName] = obj
				if(window[tagName]===undefined) return undefined
				var tmp = ''
                if(splited.length>1) {
                    for(var i = 0; i<splited.length; i++) {
                        tmp += (i!=0 ? '.' : '') + splited[i]
						if(eval(tmp)===undefined) return
					}
                }
                return eval(expr)
            },
            getIndexOf(id) {
                if(this.value.length) {
                    for(var i=0; i<this.value.length; i++) {
                        if(this.$eval('this.value['+i+'].'+this.idAttr, this) === id) return i
					}
				}
				return -1
            },
            clickOutside() {
				this.results = []
                this.removeSearchQuery()
				this.noResults = false
			},
			onFocusOut() {
				if(!this.value.length && this.search==="") {
					this.showPlaceholder = true
				}
			},
			onFocus() {
                if(this.nonAjaxData.length) {
                    this.getResults()
				}
				this.showPlaceholder = false
			},
			deleteSelectedItem(index) {
				this.value.splice(index, 1)
			},
			onClickParent() {
				this.$refs["searchfield"].focus()
				this.showPlaceholder = false
			},
			onKeyDown(e) {
				this.lastVal = e.target.value
			},
			onKeyUp(e) {
                // key controls
				if(e.keyCode===13) {
				    // enter
                    if(this.searchRequestManager!=null)
                        this.searchRequestManager.cancel();
                    if(this.keyboardCurrentItem!=-1) {
                        this.itemClicked(this.results[this.keyboardCurrentItem])
                    } else if(this.tag) {
                        if(this.search!="") {
							if(this.getIndexOf(this.search)===-1) {
                                let idAttr = this.idAttr
								let Obj = {}
                                this.$eval('Obj.'+idAttr+' = "'+this.search+'"', Obj)
								if(this.value.length && this.maxSelect>0 && this.value.length>=this.maxSelect) {
                                    this.value.splice(0, 1)
								}
							    this.value.push(Obj)
                                this.removeSearchQuery()
								this.noResults = false
								this.results = []
							} else {
                                this.removeSearchQuery()
                                this.noResults = false
                                this.results = []
							}
                        }
					}
                    return
				} else if(e.keyCode===40) {
				    // arrow down
                    if(this.results.length) {
                        const scrollbar = this.$refs.scrollbar
                        const singleRes = document.getElementsByClassName('aai-single-res')
                        let singleResHeight = singleRes[0].offsetHeight

                        if(this.keyboardCurrentItem===-1) {
                            this.keyboardCurrentItem = 0
                        } else if(this.keyboardCurrentItem<this.results.length-1) {
                            this.keyboardCurrentItem++
                        }
                        scrollbar.scrollTop = this.keyboardCurrentItem*singleResHeight
					} else {
                        this.getResults()
					}
                    return
				} else if(e.keyCode===38) {
				    // arrow up
                    if(this.results.length) {
                        const scrollbar = this.$refs.scrollbar
                        const singleRes = document.getElementsByClassName('aai-single-res')
                        let singleResHeight = singleRes[0].offsetHeight

                        if(this.keyboardCurrentItem!=-1 && this.keyboardCurrentItem>0) {
                            this.keyboardCurrentItem--
                        }
                        scrollbar.scrollTop = this.keyboardCurrentItem*singleResHeight
                    }
                    return
				}
				if(this.search==="") {
					this.results = []
				}
				if(e.keyCode===8 && this.lastVal.length===0) {
					if(this.value.length) {
						this.value.splice(this.value.length-1, 1)
					}
				} else if(this.search!="") {
					this.updateResultPosition()
					this.updateSearchFieldSize()
					this.getResults()
				} else {
					this.results = []
				}

			},
			updateSearchFieldSize() {
				this.$refs["searchfield"].style = 'width: ' + (this.search.length * 0.75 + 0.75) + 'rem'
			},
			updateResultPosition() {
				let parentPosition = this.$refs.inputbox.getBoundingClientRect()
				let top = parentPosition.top + parentPosition.height
				let left = parentPosition.left
				let width = parentPosition.width
				this.$refs.searchresults.style = 'top:' + top + 'px;left:' + left + 'px;width:' + width + 'px' 
			},
			removeSearchQuery() {
                this.search = ''
				this.updateSearchFieldSize()
			},
			getResults() {
                this.keyboardCurrentItem = -1
				let vm = this
				vm.noResults = false
				vm.updateResultPosition()
                if(vm.nonAjaxData.length) {
                    vm.results = []
                    for(var i = 0;i<vm.nonAjaxData.length;i++) {
                        if(vm.search==="" || (vm.nonAjaxData[i][vm.titleAttr]!=undefined && vm.nonAjaxData[i][vm.titleAttr].toLowerCase().indexOf(vm.search)!=-1) ) {
                            vm.results.push(vm.nonAjaxData[i])
                        }
                    }
                    if(!vm.results.length) {
                        vm.noResults = true
                    } else {
                        setTimeout(function() {
                            if(vm.$refs.scrollbar!=undefined) {
                                new PerfectScrollbar(vm.$refs.scrollbar, {
                                    wheelSpeed: 0.5,
                                    wheelPropagation: false,
                                    minScrollbarLength: 20
                                });
                            }
                        }, 200)
					}
                } else {
                    if(vm.search!="") {
                        if(vm.nonAjaxData.length===0) {
                            vm.isLoading = true
                            if(vm.searchRequestManager!=null)
                                vm.searchRequestManager.cancel();
                            const CancelToken = axios.CancelToken;
                            vm.searchRequestManager = CancelToken.source();
                            axios.get(vm.ajaxUrl, {
                                cancelToken: vm.searchRequestManager.token,
                                params: {q: vm.search},
                                headers: vm.headers
                            })
                                .then(function(res) {
                                    vm.isLoading = false
                                    vm.results = res.data
                                    if(vm.results.length) {
                                        setTimeout(function() {
                                            if(vm.$refs.scrollbar!=undefined) {
                                                new PerfectScrollbar(vm.$refs.scrollbar, {
                                                    wheelSpeed: 0.5,
                                                    wheelPropagation: false,
                                                    minScrollbarLength: 20
                                                });
                                            }
                                        }, 200)
                                    } else {
                                        vm.noResults = true
                                    }

                                })
                                .catch(function(res) {
                                    if(!axios.isCancel(res)) {
                                        vm.isLoading = false
                                    }
                                })
                        }
                    } else {
                        vm.results = []
                    }
				}

			},
			itemClicked(item) {
                let indexOfItem = this.getIndexOf(item[this.idAttr])
				if(indexOfItem===-1) {
                    if(this.maxSelect>0) {
                        if(this.value.length && this.value.length>=this.maxSelect) {
                            this.value.splice(0, 1)
						}
                    }
					this.value.push(item)
				} else {
					if(this.removeSelectedOnClickSearchResults) {
						this.value.splice(this.value.indexOf(item[this.idAttr]), 1)
					}
				}
				this.results = []
				this.removeSearchQuery()
				this.updateSearchFieldSize()
				this.$emit('item-clicked', item)
				if(!this.nonAjaxData.length) {
                    this.$refs["searchfield"].focus()
                }
			}
		}
	};
</script>
<style>
	.aai-loading {
		position: absolute;
		right: 0;
		top: 0;
	}
	@-webkit-keyframes rotation {
		from {
			-webkit-transform: rotate(0)
		}

		to {
			-webkit-transform: rotate(359deg)
		}
	}

	@keyframes rotation {
		from {
			transform: rotate(0)
		}

		to {
			transform: rotate(359deg)
		}
	}
	.fade.in .spinner, .fade.in .spinner-small, .fade.show .spinner, .fade.show .spinner-small {
		-webkit-animation: rotation .6s infinite linear;
		animation: rotation .6s infinite linear;
	}
	.ajax-autocomplete-input .spinner, .ajax-autocomplete-input .spinner-xs {
		height: 16px;
		width: 16px;
		position: absolute;
		right: 8px;
		top: 8px;
		transform: translate(15px, 10px);
		border: 2px solid rgba(0,0,0,.5);
		border-top: 2px solid #fff;
		border-radius: 100%;
	}

	.ajax-autocomplete-input {
		display: -ms-flexbox;
		display: -webkit-box;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-ms-flex-align: stretch;
		-webkit-box-align: stretch;
		align-items: stretch;
		width: 100%;
		position: relative;
	}
	.ajax-autocomplete-input > .input-box {
		cursor: text;
		height: auto;
		padding: 0 12px 0;
		min-height: 28px;
		border-radius: 0.25rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		border: 1px solid #ccc;
		margin: 0;
		position: relative;
		-ms-flex: 1 1 auto;
		-webkit-box-flex: 1;
		flex: 1 1 auto;
		width: 1%;
		margin-bottom: 0;
		display: block;
		background: rgba(255,255,255,.25);
	}
	.ajax-autocomplete-input > .input-box input {
		width: 0.75rem;
		background: transparent;
		border: none;
		outline: 0;
		box-shadow: none;
		-webkit-appearance: textfield;
		border: none;
		font-size: 14px !important;
		padding: 2px 0;
		line-height: 14px;
		color: #ccc;
	}
	.ajax-autocomplete-input > .input-box input:focus {
		box-shadow: none;
		border: none;
		outline: none;
	}
	.ajax-autocomplete-input .aii-results-parent {
		background: #333;
		margin-top: -5px;
		border-radius: 0 0 .25rem .25rem;
		z-index: 3;
	}
	.ajax-autocomplete-input ul.aai-results {
		margin: 0;
		list-style: none;
		padding: 12px 12px;
		overflow: hidden;
	}
	.ajax-autocomplete-input ul.aai-results > li {
		height: 38px;
		position: relative;
		margin-top: 4px;
		cursor: pointer;
	}
	.ajax-autocomplete-input ul.aai-results > li:hover, .ajax-autocomplete-input ul.aai-results > li.active {
		background-color: #222;
	}
	.ajax-autocomplete-input ul.aai-results > li:first-child {
		margin-top: 0;
	}
	.ajax-autocomplete-input ul.aai-results > li .ajax-autocomplete-input-txts {
		padding-top: 3px;
		line-height: 15px;
	}
	.ajax-autocomplete-input ul.aai-results > li:not(.has-subtitle) .ajax-autocomplete-input-txts {
		padding-top: 10px;
	}
	.ajax-autocomplete-input ul.aai-results > li.has-image {
		padding-left: 45px;
	}
	.ajax-autocomplete-input ul.aai-results > li.just-title {
		height: 20px;
	}
	.ajax-autocomplete-input ul.aai-results > li:not(.has-image) {
		padding-left: 5px;
	}
	.ajax-autocomplete-input ul.aai-results > li.just-title .ajax-autocomplete-input-txts {
		padding-top: 2px;
	}
	.ajax-autocomplete-input ul.aai-results > li.just-title .ajax-autocomplete-input-txts .ajax-autocomplete-input-title {
		font-size: 13px !important;
	}
	.ajax-autocomplete-input ul.aai-results > li > img {
		position: absolute;
		left: 0;
		top: 0;
	}

	.ajax-autocomplete-input ul.aai-results > li span {
		display: block;
		color: #fff;
	}
	.ajax-autocomplete-input-title {
		font-size: 15px;
	}
	.ajax-autocomplete-input-subtitle {
		font-size: 10px;
	}
	ul.aai-selected-list {
		list-style: none;
		box-sizing: border-box;
		list-style: none;
		margin: 0;
		padding: 0;
		width: 100%;
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		float: left;
	}
	ul.aai-selected-list > li {
		display: inline-block;
		float: left;
		list-style: none;
		line-height: 24px;
		padding: 5px 5px;
	}
	ul.aai-selected-list > li.aai-selected-item {
		margin-right: 5px;
		margin-right: 5px;
	}
	.aai-selected-item-img {
		float: left;
		cursor: pointer;
		margin-right: 4px;
		border-radius: 50%;
		overflow: hidden;
		display: inline-block;
		width: 24px;
		height: 24px;
		position: relative;
	}
	.aai-selected-item-img img {
		vertical-align: top;
	}
	.aai-selected-item-img::after {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5) url("data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ0aW1lcyIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLXRpbWVzIGZhLXctMTEiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzUyIDUxMiI+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTTI0Mi43MiAyNTZsMTAwLjA3LTEwMC4wN2MxMi4yOC0xMi4yOCAxMi4yOC0zMi4xOSAwLTQ0LjQ4bC0yMi4yNC0yMi4yNGMtMTIuMjgtMTIuMjgtMzIuMTktMTIuMjgtNDQuNDggMEwxNzYgMTg5LjI4IDc1LjkzIDg5LjIxYy0xMi4yOC0xMi4yOC0zMi4xOS0xMi4yOC00NC40OCAwTDkuMjEgMTExLjQ1Yy0xMi4yOCAxMi4yOC0xMi4yOCAzMi4xOSAwIDQ0LjQ4TDEwOS4yOCAyNTYgOS4yMSAzNTYuMDdjLTEyLjI4IDEyLjI4LTEyLjI4IDMyLjE5IDAgNDQuNDhsMjIuMjQgMjIuMjRjMTIuMjggMTIuMjggMzIuMiAxMi4yOCA0NC40OCAwTDE3NiAzMjIuNzJsMTAwLjA3IDEwMC4wN2MxMi4yOCAxMi4yOCAzMi4yIDEyLjI4IDQ0LjQ4IDBsMjIuMjQtMjIuMjRjMTIuMjgtMTIuMjggMTIuMjgtMzIuMTkgMC00NC40OEwyNDIuNzIgMjU2eiI+PC9wYXRoPjwvc3ZnPg==") center center no-repeat;
		opacity: 0;
		background-size: 10px;
	}
	ul.aai-selected-list > li.aai-selected-item:hover .aai-selected-item-img::after {
		opacity: 1;
	}
	ul.aai-selected-list > li img {
	}
	.aai-result-img {
		position: relative;
		margin-right: 4px;
	}
	.aai-result-img:after {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3)	
	}
	ul.aai-selected-list > li img:after {
		
	}
	span.aai-txt {
		float: left;
		line-height: 20px;
		font-size: 14px;
		padding-top: 2px;
	}
	.aii-results-parent {
		position: fixed;
	}
	.ps__rail-y, .ps__rail-x {
		display: none !important;
	}
	.aai-nores {
		padding: 5px;
		color: #fff;
		font-size: 12px;
	}
	.aai-res-active {
		background-color: #272727
	}
	.aai-placeholder {
		color: #999;
	}
</style>
